"use strict";
var TypeaheadHelper = (function () {
    function TypeaheadHelper() {
    }
    TypeaheadHelper.extractTypeaheadValue = function (sourceObject, dataMemeber) {
        if (dataMemeber === void 0) { dataMemeber = 'name'; }
        var returnValue = null;
        if (typeof sourceObject === 'string') {
            returnValue = sourceObject;
        }
        else if (sourceObject && sourceObject[dataMemeber]) {
            returnValue = sourceObject[dataMemeber];
        }
        return returnValue;
    };
    return TypeaheadHelper;
}());
exports.TypeaheadHelper = TypeaheadHelper;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/type-ahead/typeahead.helper.js